import { useQuery } from "@tanstack/react-query";
import { getPosterStatistics } from "../../api/posters";
import "./PosterStatusBar.css";

interface PosterStatusBarProps {
    campaignId: string;
}

const fmt = (n: number) => new Intl.NumberFormat("sv-SE").format(n);

export const PosterStatusBar = ({ campaignId }: PosterStatusBarProps): JSX.Element | null => {
    const { data: stats } = useQuery({
        queryKey: ["posters", "statistics", campaignId],
        queryFn: () => getPosterStatistics(campaignId),
        refetchInterval: 30_000,
        staleTime: 15_000
    });

    if (!stats) return null;

    return (
        <div className="poster-status-bar" role="status" aria-label="Affischstatistik">
            <span className="poster-status-bar__icon" aria-hidden="true">🪧</span>
            <div className="poster-status-bar__stat">
                <span className="poster-status-bar__label">Teamet idag</span>
                <span className="poster-status-bar__value">{fmt(stats.teamTodayCount)} st</span>
            </div>
            <div className="poster-status-bar__divider" />
            <div className="poster-status-bar__stat">
                <span className="poster-status-bar__label">Totalt</span>
                <span className="poster-status-bar__value">{fmt(stats.teamTotalCount)} st</span>
            </div>
            {stats.myTodayCount > 0 && (
                <>
                    <div className="poster-status-bar__divider" />
                    <div className="poster-status-bar__stat">
                        <span className="poster-status-bar__label">Jag idag</span>
                        <span className="poster-status-bar__value">{fmt(stats.myTodayCount)} st</span>
                    </div>
                </>
            )}
        </div>
    );
};
